(function() {
  var placeholder = document.getElementById('calculator');
  var calc = document.querySelector('.calc-wrap');
  if (placeholder && calc) {
    placeholder.appendChild(calc);
  }
})();

function calculate() {
  var protein = parseFloat(document.getElementById('protein-input').value) || 0;
  var sugar = parseFloat(document.getElementById('sugar-input').value) || 0;

  var proteinScore = Math.min(protein / 15, 1) * 6;
  var sugarPenalty = Math.min(sugar / 20, 1) * 4;
  var rawScore = 10 - sugarPenalty + (proteinScore - 3);
  var score = Math.min(10, Math.max(0, rawScore));
  var rounded = Math.round(score * 10) / 10;

  var card = document.getElementById('result-card');
  var label = document.getElementById('result-label');
  var verdict = document.getElementById('result-verdict');
  var desc = document.getElementById('result-desc');
  var bar = document.getElementById('ratio-bar');
  var scoreDisplay = document.getElementById('score-display');

  card.className = 'result-card';
  label.className = 'result-label';
  verdict.className = 'result-verdict';
  desc.className = 'result-desc';

  if (score < 4) {
    card.classList.add('result-danger');
    label.classList.add('result-label-danger');
    verdict.classList.add('result-verdict-danger');
    desc.classList.add('result-desc-danger');
    label.textContent = 'High crash risk';
    verdict.textContent = 'This snack will likely make the slump worse.';
    desc.textContent = 'Low protein and high sugar is the exact combination that spikes blood glucose and drops it fast. You\'ll feel fine for 20 minutes, then worse than before. Add a protein source or swap entirely.';
    bar.style.background = '#E24B4A';
  } else if (score < 7) {
    card.classList.add('result-warning');
    label.classList.add('result-label-warning');
    verdict.classList.add('result-verdict-warning');
    desc.classList.add('result-desc-warning');
    label.textContent = 'Moderate — room to improve';
    verdict.textContent = 'Better than most, but not crash-proof.';
    desc.textContent = 'Your snack has some staying power but the sugar content may still cause a mild dip. Pairing it with a higher-protein option — nuts, Greek yogurt, or a protein-forward snack — would stabilize the energy curve.';
    bar.style.background = '#EF9F27';
  } else {
    card.classList.add('result-success');
    label.classList.add('result-label-success');
    verdict.classList.add('result-verdict-success');
    desc.classList.add('result-desc-success');
    label.textContent = 'Sustained energy';
    verdict.textContent = 'Solid choice. This snack works with your body.';
    desc.textContent = 'High protein and low sugar means a slower, steadier digestion curve. Your blood glucose stays stable and you\'ll stay focused well past the 3 PM window. This is exactly what an afternoon snack should do.';
    bar.style.background = '#639922';
  }

  scoreDisplay.textContent = rounded.toFixed(1);
  bar.style.width = Math.round(score * 10) + '%';
  document.getElementById('your-score-compare').textContent = rounded.toFixed(1);
  document.getElementById('result-section').classList.remove('hidden');
}
